import {ValueObject} from '@s-ui/domain'

import {ContactDealerError} from '../Errors/ContactDealerError.js'

export default class ContactInformationValueObject extends ValueObject {
  /**
   * @constructor
   * @param {Object} data
   * @param {String} data.name
   * @param {String} data.phone
   * @param {String} data.email
   * @param {String} data.stock
   * @param {String} data.callMeNow
   */

  /**
   * Validation method
   */
  static validate({name, phone, email}) {
    if (!name) {
      throw new ContactDealerError('😭 Invalid name.')
    }
    if (!phone) {
      throw new ContactDealerError('😭 Invalid phone.')
    }
    if (!email) {
      throw new ContactDealerError('😭 Invalid email.')
    }
  }

  getCallMeNow() {
    return this._callMeNow
  }

  getIsNow() {
    return this._callMeNow === 0
  }
}
